export default "__VITE_ASSET__CqQh1heo__"